<template>
	<div>
		<div v-if="this.emailData.type == 'withoutDetails' || this.emailData.type == 'openedFromAssessment'" class="custom-send-email" >
		<b-form-group label-cols="2" label="From:" class="my-2 send-from">
			<b-form-input
				type="email"
				v-model="From"
				required disabled />
		</b-form-group>
		<b-form-group label-cols="2" label="To:" class="my-2 send-to custom-accordion">
			<multiselect 
				v-model="selectedToValue" 
				tag-placeholder="Enter email" 
				placeholder="Search or add a email" 
				
				:options="getProspectEmails" 
				:multiple="true" 
				:taggable="true" 
				@tag="addToEmail"
				:hideSelected="true"
				:showLabels='false'>
			</multiselect>
		</b-form-group>
		<b-form-group label-cols="2" label="CC:" class="my-2 send-cc custom-accordion">
			<multiselect 
				v-model="selectedCCValue" 
				tag-placeholder="Enter email" 
				placeholder="Search or add a email" 
				:options="getProspectEmails" 
				:multiple="true" 
				:taggable="true" 
				@tag="addCCEmail"
				:hideSelected="true"
				:showLabels='false'>
			</multiselect>
		</b-form-group>
		<b-form-group label-cols="2" label="BCC:" class="my-2 send-bcc custom-accordion">
			<multiselect 
				v-model="selectedBCCValue" 
				tag-placeholder="Enter email" 
				placeholder="Search or add a email"
				:options="getProspectEmails" 
				:multiple="true" 
				:taggable="true" 
				@tag="addBCCEmail"
				:hideSelected="true"
				:showLabels='false'
				>
			</multiselect>
		</b-form-group>
		<b-form-group label-cols="2" label="Template:" class="my-2 send-template">
			<b-dropdown id="dropdown-1" :text="SelectEmailTempl" class="customdrop m-md-2" v-model="SelectedTemplate" >
				<b-dropdown-item 
				:value="UserTemplate.Name" 
				v-for="UserTemplate in user.EmailTemplate" :key="UserTemplate.Name"
				@click="OnChangeTemplate(UserTemplate)">
				{{UserTemplate.Name}} <span @click="TemplateDelete(UserTemplate.Name)" class="removetemplspan" title="Delete"><v-icon class="text-white" name="times" /></span> 
				</b-dropdown-item>
			</b-dropdown>
		</b-form-group>
		<!-- <b-form-group label-cols="2" label="Template:" class="my-2 send-template">
			<multiselect 
				v-model="SelectedTemplate" 
				:options="user.EmailTemplate" 
				placeholder="Select Email Template" 
				label="Name" 
				track-by="Name"
				:searchable="false"
				@select="onTemplateSelection">
			</multiselect>
		</b-form-group> -->
		<b-form-group label-cols="2" label="Subject:" class="my-2 send-subject custom-accordion">
			<b-form-input v-model="Subject"/>
		</b-form-group>
		
		<b-form-group label-cols="2" label="Message:" class="my-2 send-editor">

			<b-form-group class="dynamicformdivemail">
				<b-form-select v-model="dynamicTags" @change="makeDynamicTags()">
					<b-form-select-option value="">Insert Variable</b-form-select-option>
					
					<option value="firstName">Prospect First Name</option>
					<option value="lastName">Prospect Last Name</option>
					<option value="email">Prospect Email</option>
					<option value="number">Prospect Number</option>

					<option value="OfficeName">Office Name</option>
					<option value="OfficeAddress">Office Address</option>
					
					<option value="ManagerFirstName">Manager First Name</option>
					<option value="ManagerLastName">Manager Last Name</option>
					<option value="ManagerEmail">Manager Email</option>
					<option value="ManagerNumber">Manager Number</option>
					
					<option value="InterviewDate">Interview Date</option>
					<option value="InterviewTime">Interview Time</option>
				
				</b-form-select>
			</b-form-group>

			<!-- <textarea v-if="this.emailData.type == 'openedFromAssessment'" v-model="Message"></textarea> -->
			<editor v-if="this.emailData.type == 'openedFromAssessment'" apiKey="0oexfbbn6tqpt67rcwq79gp2hnq7phni8q4agezn3wl857hj" :init={} v-model="Message" />
			<vue-editor v-else ref="vEditor" v-model="Message"></vue-editor>
			
		</b-form-group>

		<b-form-group label-cols="2" label="Use Email Signature:" class="my-2 send-subject custom-accordion">
            <input type="checkbox" class="emailsigncheckbox" v-model="emailSignCheckBoxSelected" @change="emailSignatureCheckbox($event)" />
			<div class="ress send-editor">
				<vue-editor ref="vEditor" v-model="MessageSign" :disabled="disabledStatus" ></vue-editor>
			</div>
		</b-form-group>

		<div class="cutom-fileUploder row">
			<div class="col-2"></div>
			<div  class="pl-10 " style="position:relative;">
				<input id="fileUpload" type="file" @change="changeFile($event)" style="cursor:pointer;margin-bottom:10px;height: 46px;opacity: 0;z-index: 9999;position: relative;"> 
				<div class="cutom-inputuploder">
					<span>Attach Document Here</span>
					<span><v-icon name="plus" class="" /></span>
				</div>
				<div v-if="attachmentArray.length">
					<div v-for="(attach,i) in attachmentArray" :key="i" class="attach-file-content">
						<span>{{attach.filename}}</span>
						<div @click="deleteAttachment(i)"><v-icon style="cursor:pointer;" name="trash" class="trash-icon-custom" /></div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-2"></div>
			<div class="pl-10">
				<b-button v-if="!isSending" variant="outline-primary" style="margin-right:10px" @click="sendEmail">Send Email</b-button>
				<b-button v-if="isSending" variant="outline-primary" style="margin-right:10px">Sending...</b-button>
				<b-button v-if="!isReply" variant="outline-primary" @click="saveNewTemplate">Save as Template</b-button>
			</div>
		</div>
		<!-- <div v-for="(mail,i) in this.mails" :key="i"> -->
			<div style="border-top: 1px solid #e8e8e8;margin-top: 15px;"></div>
			<div v-if="isReply" class="custom-email-content" style="padding-top:15px;">
				<div class="custom-email-content-load" style="margin-left: 67px;" v-html="this.emailData.message.Content"></div>
				<!-- <div  class="custom-email-content-load" style="margin-left: 67px;" v-html="mail.Content"></div> -->
				
			</div>
		<!-- </div> -->
		<div style="border-bottom: 1px solid #e8e8e8;"></div>

			<b-modal
				id="TemplateNameModal"
				ref="modal"
				title="Submit Your Name"
				@show="resetModal"
				@hidden="resetModal"
				@ok="handleOk"
			>
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-form-group
					label="Name"
					label-for="name-input"
					invalid-feedback="Template Name is required"
					:state="nameState"
					>
					<b-form-input
						id="name-input"
						v-model="TemplateName"
						:state="nameState"
						required
					></b-form-input>
					</b-form-group>
				</form>
			</b-modal>
		</div>
		<div v-if="this.emailData.type == 'withDetails'" class="custom-email-view">
			<div class="custom-user-content"> 
				<div class="custom-email-user">
					<v-icon name="user" class="" />
				</div>
				<div class="custos-email-right">
					<div class="custom-subject-content">
						<p>{{this.emailData.message.Subject}}</p>
						<div class="reply-btn">
							<b-button variant="outline-primary" class="" @click="replyAllClick()">
								<v-icon style="cursor:pointer;" name="reply"  />
								<span>Reply All</span>
							</b-button>
						</div>
					</div>
					<div class="custom-subject-content reply-all">
						<div class="reply-btn">
							<b-button variant="outline-primary" class="" @click="replyClick()">
								<v-icon style="cursor:pointer;" name="reply"  />
								<span>Reply</span>
							</b-button>
						</div>
					</div>
					<div class="custom-email-view-from custom-padding">
						<div>
							<span><label class="cusrom-label">From : </label> <strong>{{' ' + this.emailData.message.From}}</strong></span><br>
							<span>
								<label class="cusrom-label">To : </label> 
								<strong v-if="getTOtype == 'object'">{{' ' + this.emailData.message.TO.join()}}</strong>
								<strong v-if="getTOtype  == 'string'">{{' ' +this.emailData.message.TO}}</strong>
							</span>
							<!-- <span v-if="getTOtype  == 'string' "><label class="cusrom-label">TO :</label> <strong>{{this.emailData.message.TO}}</strong></span> -->
						</div>
					</div>
					<div class="custos-email-right-cc">
						<div class="custom-email-view-cc">
							<span v-if="this.emailData.message.CC.length">
								<label class="cusrom-label">Cc : </label> 
								<span v-if="typeof this.emailData.message.CC == 'object'">{{' ' +this.emailData.message.CC.join()}}</span>
								<span v-if="typeof this.emailData.message.CC == 'string'">{{' ' +this.emailData.message.CC}}</span>
							</span>
							<span v-if="this.emailData.message.BCC.length" class="custom-email-view-bcc">
								<label class="cusrom-label">Bcc : </label> 
								<span v-if="typeof this.emailData.message.BCC == 'object'">{{' ' + this.emailData.message.BCC.join()}}</span>
								<span v-if="typeof this.emailData.message.BCC == 'string'">{{' ' + this.emailData.message.BCC}}</span>
							</span>
						</div>
						<div>
							<span class="custom-email-time"><label class="cusrom-label">Date :</label> <span>{{time}}</span></span>
						</div>
					</div>
				</div>
			</div>
			<div class="custom-email-content custom-reply-email">
				<div class="custom-email-content-load" v-html="getConvertedText"></div>
				<!-- <div v-for="(mail,i) in this.mails" :key="i" class="custom-email-content-load" v-html="mail.Content"></div> -->
				<div style="position:relative;">
					<div v-if="this.emailData.message.Attachment.length">
						<div v-for="(attach,i) in this.emailData.message.Attachment" :key="i" class="attach-file-content custom-email-file mt-3">
							<div><v-icon style="cursor:pointer;" name="file" class="trash-icon-custom" /></div>
							<span class="pl-2" style="cursor:pointer;"><a target="blank" :href="attach.path">{{attach.name}}</a></span>
						</div>
					</div>
				</div>
					<!-- <b-button variant="outline-primary" class="mt-4" @click="replyClick()">Reply</b-button> -->
			</div>
		</div>
	</div>


	
</template>

<script>
	import { mapState } from 'vuex'
	import { VueEditor } from "vue2-editor";
	import axios from "axios";
	import { db,fbstore,storeEmail } from 'src/db'
	import Editor from '@tinymce/tinymce-vue'
	import Multiselect from 'vue-multiselect'
	import moment from 'moment';
	export default {
		name: "EmailModal",
		props: {
			error: String,
			emailData:{}
		},
		components: {
			VueEditor,
			Multiselect,
			editor: Editor
		},
		computed: {
			getConvertedText() {
				// var urlRegex = /(https?:\/\/[^\s]+)/g;
				let ab = this.emailData.message.Content.indexOf("<a");
				let dd = this.emailData.message.Content;
				let cc = dd.slice(0,(ab+3)) +  "target='_blank' " + dd.slice(ab+3);
				// return this.emailData.message.Content.replace(urlRegex, function(url) {
				// 	return '<a href="' + url + '"'+'target="_blank"'+'>' + url + '</a>';
				// });
				
				return cc
			},
			getProspectEmails() {
				
				let emails = [];
				for (let p of this.prospects) {
					if (p.Email) {
						emails.push(p.Email)
					}
				}
				return emails
			},
			time() {
				// this.getFileContent();
				if (this.emailData.message.Date) {
					if (this.isNotToday(this.emailData.message.Date)) {
						return this.$parsePlainDate(this.emailData.message.Date) + ' ' + this.$parsePlainTime(this.emailData.message.Date);
					}else {
						return this.$parsePlainTime(this.emailData.message.Date);
					}
					// return this.$parseDate(this.emailData.message.Date);
				}
				return null
			},
			getTOtype() {
				let tp = typeof this.emailData.message.TO;
				return tp
			},
			...mapState('globals', ['activeProsp']),
			...mapState('firebase', ['prospects','user','mails']),
		},
		methods: {
			// MANAGE DYNAMIC TAGS
			makeDynamicTags() {
				if(this.dynamicTags) {
					var bindMsgData = '';
					bindMsgData = this.Message+' '+`{{${this.dynamicTags}}}`;
					this.Message = bindMsgData.replace(/(<p>|<\/p>)/g, "");
				}
			},
			// EMAIL SIGNATURE
			emailSignatureCheckbox(e) {
                if(this.user.hasOwnProperty('EmailSignature')) {
                    if(e.target.checked == true) {
						this.checkSign = 1;
						this.MessageSign = this.user.EmailSignature;
					} else {
                        if (confirm("Once you uncheck, Your signature data will erase?")) {
                            this.MessageSign = '';
							this.checkSign = 0;
                        } else {
							setTimeout(() => {
								this.emailSignCheckBoxSelected = true;
							}, 0);
                        }
                    }
                }
            },
			TemplateDelete(TemplateName) {
				var selectedTemplateName = TemplateName;
				if(selectedTemplateName != '') {
					if (confirm("Are you sure you want to delete this template?")) {
						var i=0;
						for (let temp of this.user.EmailTemplate) {
							if (selectedTemplateName == temp.Name) {
								this.user.EmailTemplate.splice(i,1)
								this.SelectedTemplate='';
								this.Subject='';
								this.Message='';
								this.TemplateName='';
								//eslint-disable-next-line
								console.log('Template Successfully Deleted');
								this.SelectEmailTempl = 'Select Email Template';
							}
							i++;
						}
						db.doc(`Users/${this.$store.state.firebase.user.id}`).update({ EmailTemplate: this.user.EmailTemplate });
					}
				} else {
					alert('Please Select Template');
				}
			},
			getFileContent:async function() {
				await axios.get("C:/Users/admin/Downloads/Another%20Email.html")
				.then(response => {
					//eslint-disable-next-line
					console.log(response);
				});
				return 'hardikkkkk'
			},
			isNotToday(milliseconds) {
				let date = new Date(parseInt(milliseconds));
				let now = new Date();
				if (date.getFullYear() === now.getFullYear() &&
					date.getMonth() === now.getMonth() &&
					date.getDate() === now.getDate()) {
					return false;
				}
				return true;
			},
			sendEmail() {
				if (this.From && this.selectedToValue.length && this.Subject && this.Message) {
					if (confirm("Are you sure you want to send this email?")) {
						this.isSending = true;
						const smsData = {
							toEmail:this.selectedToValue,
							bccEmail:this.selectedBCCValue,
							fromEmail:this.From,
							fromName:this.emailData.user.First + ' '+ this.emailData.user.Last,
							ccEmail:this.selectedCCValue,
							subject:this.Subject,
							body:this.getMessage()+''+this.signbody(),
							fileName:this.fileName,
							fileType:this.fileType,
							filePath:this.filePath,
							attachmentData:this.attachmentArray,
							textBody:this.getEditorText()
						};
						this.checkSign = 0;
						// http://localhost:5000/tatext-thirdpool/us-central1/tatext
						// https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext
						// const ref = fbstore.ref().child('Template/'+this.Subject+'.html');
						// ref.putString(this.Message).then((snapshot) => {
						// 	// eslint-disable-next-line
						// 	console.log('Uploaded a raw string!',snapshot);
						// });
						axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/sendEmail", smsData)
						.then(response => {
							this.isSending = false;
							this.$bvModal.hide('EmailModal');
							//eslint-disable-next-line
							console.log(response);
							// let contentURL = ''
							// if (response.status === 200) {
							// 	for (let p of this.prospects) {
							// 		if (this.selectedToValue.indexOf(p.Email) > -1) {
							// 			this.storeMailData(p.id);
							// 		}
							// 	}
							// 	// const ref = fbstore.ref().child('Template/'+this.Subject+'.html').putString(this.Message);
							// 	// ref.on(`state_changed`,snapshot=>{
							// 	// 	// eslint-disable-next-line
							// 	// 	console.log('Uploaded a raw string!',snapshot);
							// 	// }, 
							// 	// error=>{
							// 	// 	//eslint-disable-next-line
							// 	// 	console.log(error.message)
							// 	// },
							// 	// ()=>{
							// 	// 	ref.snapshot.ref.getDownloadURL().then((url)=>{
							// 	// 		contentURL = url;
							// 	// 		storeEmail({
							// 	// 			From: this.From,
							// 	// 			Uid:this.user.Uid,
							// 	// 			ProspectID:this.emailData.prospect.id,
							// 	// 			TO:this.selectedToValue,
							// 	// 			Attachment:this.filesArray,
							// 	// 			BCC:this.selectedBCCValue,
							// 	// 			CC:this.selectedCCValue,
							// 	// 			Content:contentURL,
							// 	// 			Subject:this.Subject
							// 	// 		})
							// 	// 		.then((data) => {
							// 	// 			//eslint-disable-next-line
							// 	// 			console.log(data);
							// 	// 		})
							// 	// 		.catch(err => alert(`Failure storing email: ${err.response.data.message}`));
							// 	// 	});
							// 	// });
								
							// }
							setTimeout(() => {
								this.$bvToast.toast('Email is sent successfully!', {
									title: `Success`,
									variant: 'success',
									solid: true
								});
							}, 500);
							
						}).catch(err => 
							this.$bvToast.toast(`Failure Sending Email: ${err}`, {
								title: `Error`,
								variant: 'danger',
								solid: true
						})
						);
					}
				}else {
					alert('Please add From,To,Subject and Message');	
				}
			},
			storeMailData(pid) {
				storeEmail({
					From: this.From,
					Uid:this.user.Uid,
					// ProspectID:this.emailData.prospect.id,
					ProspectID:pid,
					TO:this.selectedToValue,
					Attachment:this.filesArray,
					BCC:this.selectedBCCValue,
					CC:this.selectedCCValue,
					// Content:contentURL,
					// Content:this.Message,
					Content:this.getMessage(),
					Subject:this.Subject
				})
				.then((data) => {
					//eslint-disable-next-line
					console.log(data);
				})
				.catch(err => alert(`Failure storing email: ${err.response.data.message}`));
			},
			changeFile(event) {
				this.fileData = event.target.files[0];
				this.fileName = event.target.files[0].name;
				this.onUpload();
				var reader = new FileReader();
				reader.readAsDataURL(this.fileData);
				setTimeout(() => {
					let abc = reader.result.split(',');
					this.filePath = abc[1];
					this.fileType = this.fileData.type;
					
				}, 100);
			},
			onUpload(){
				// const ref = fbstore.ref().child('Template/'+this.Subject+'.html').putString(this.Message);
				const storageRef = fbstore.ref('Attachments/'+this.emailData.prospect.id+'/'+this.fileData.name).put(this.fileData);
				storageRef.on(`state_changed`,snapshot=>{
					this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
				}, error=>{
					//eslint-disable-next-line
					console.log(error.message)
				},
				()=>{this.uploadValue=100;
					storageRef.snapshot.ref.getDownloadURL().then((url)=>{	
						this.uploadedURL = url;
						this.attachmentArray.push({
							'content':this.uploadedURL,
							'filename':this.fileName,
							'type':this.fileType,
							'content_id':this.fileName,
							// 'storedFilePath':this.uploadedURL
						});
						this.filesArray.push({'name':this.fileName,'path':this.uploadedURL});
					});
				});
			},
			deleteAttachment(index) {
				var storageRef = fbstore.ref().child('Attachments/'+this.emailData.prospect.id+'/'+this.attachmentArray[index].filename);
				storageRef.delete().then(() => {
					this.attachmentArray.splice(index,1);
				}).catch((error) => {
					//eslint-disable-next-line
					console.log('errror',error);
				});
				// this.attachmentArray.splice(index,1);
			},
			saveNewTemplate() {
				if (this.Subject && this.Message) {
					this.$bvModal.show('TemplateNameModal');
				}else {
					alert('Please enter subject and body ');
				}
			},
			checkFormValidity() {
				const valid = this.$refs.form.checkValidity()
				this.nameState = valid
				return valid
			},
			resetModal() {
				this.name = ''
				this.nameState = null
			},
			handleOk(bvModalEvt) {
				// Prevent modal from closing
				bvModalEvt.preventDefault()
				// Trigger submit handler
				this.handleSubmit();
			},
			handleSubmit() {
				// Exit when the form isn't valid
				if (!this.checkFormValidity()) {return}
				let EmailTemplate = this.user.EmailTemplate ? this.user.EmailTemplate : [];
				
				let data = EmailTemplate.find(et => et.Name == this.TemplateName)
				if (data) {
					alert('This Template Name is already exist');
					return
				}
				EmailTemplate.push({
					'Name':this.TemplateName,
					'Subject':this.Subject,
					'Body':this.Message,
					'Attachement':this.attachmentArray
				});
				db.doc(`Users/${this.user.id}`).update({ EmailTemplate: EmailTemplate });
				// Hide the modal manually
				this.$bvToast.toast('New Email Template is saved!', {
					title: `Success`,
					variant: 'success',
					solid: true
				})
				this.$nextTick(() => {this.$bvModal.hide('TemplateNameModal')})
			},
			addToEmail(newTag) {
				this.selectedToValue.push(newTag)
			},
			addCCEmail(newTag) {
				this.selectedCCValue.push(newTag)
			},
			addBCCEmail(newTag) {
				this.selectedBCCValue.push(newTag)
			},
			getSelectedTO() {
				if (this.emailData && this.emailData.prospect && this.emailData.prospect.Email) {
					this.selectedToValue.push(this.emailData.prospect.Email);
				}
			},
			getSelectdBCC() {
				if (this.emailData.user.SendGrid) {
					this.selectedBCCValue.push(this.emailData.user.SendGrid);
				}
			},
			onTemplateSelection(selectedOption) {
				this.Subject = selectedOption.Subject,
				this.Message = selectedOption.Body
			},
			OnChangeTemplate(SelectedTemplate) {
				var SelectedTemplateName = SelectedTemplate.Name;
				let data = this.user.EmailTemplate.find(et => et.Name == SelectedTemplateName)
				this.Subject = data.Subject,
				this.Message = data.Body,
				this.TemplateName = data.Name
				this.SelectEmailTempl = data.Name
				this.attachmentArray =data.Attachement ? data.Attachement : []
			},
			getEditorText() {
				// return this.$refs.vEditor.quill.getText();
				var span = document.createElement('span');
				span.innerHTML = this.Message;
				return span.textContent || span.innerText;
			},
			getMessage(){
				let officeName = '';
				let officeAddress = '';
				let mergeOfficeAddress = '';
				let managerFirstName = '';
				let managerLastName = '';
				let managerEmail = '';
				let managerNumber = '';

				if(this.user.Offices) {
					let getOfficeData = this.user.Offices.find(um => um.OfficeId === this.emailData.prospect.Office);
					if(getOfficeData) {
						// OFFICE DATA
						officeName = getOfficeData.OfficeName ? getOfficeData.OfficeName: '';
						officeAddress = getOfficeData.StreetAddress ? getOfficeData.StreetAddress : '';
						let officeCity = getOfficeData.City ? getOfficeData.City : '';
						let officeState = getOfficeData.State ? getOfficeData.State : '';
						let officeZipCode = getOfficeData.ZipCode ? getOfficeData.ZipCode : '';
						mergeOfficeAddress = `${officeAddress} ${officeCity} ${officeState} ${officeZipCode}`;
						// MANAGER DATA
						if(getOfficeData.MgrID) {
							let managerData = this.user.Managers.find(um1 => um1.MgrID === getOfficeData.MgrID);
							if (managerData) {
								managerFirstName = managerData.First ? managerData.First : '';
								managerLastName = managerData.Last ? managerData.Last : '';
								managerEmail = managerData.Email ? managerData.Email : '';
								if(managerData.Number) {
									managerNumber = this.$parseNumber(managerData.Number)
								}
							}
						}
					}
				}
				
				// PROSPECT
				let edited = this.Message.replace(/{{firstName}}/g, this.emailData.prospect.First ? this.emailData.prospect.First : '');
				edited = edited.replace(/{{lastName}}/g, this.emailData.prospect.Last ? this.emailData.prospect.Last : '');
				edited = edited.replace(/{{email}}/g, this.emailData.prospect.Email ? this.emailData.prospect.Email : '');
				edited = edited.replace(/{{number}}/g, this.$parseNumber(this.emailData.prospect.Number));

				if(this.emailData.prospect.hasOwnProperty('Interviewed') && this.emailData.prospect.Interviewed) {
					let InterviewDateTimezoneWise;
					let getTimeZoneDetails = '';
					if(this.user.hasOwnProperty('TimeZone')) {
						let getUserTimezone = this.user.TimeZone;
						let getInterviewTimeData = this.emailData.prospect.Interviewed;
						var datea = new Date(getInterviewTimeData);
						var Pacific, Mountain, Central, Eastern;
						if(getUserTimezone == 0) {
							Pacific = datea.toLocaleString('en-US', { timeZone: 'Canada/Pacific', });
							InterviewDateTimezoneWise = moment(Pacific).valueOf();
							getTimeZoneDetails = "Pacific Time";
						}
						if(getUserTimezone == 1) {
							Mountain = datea.toLocaleString('en-US', { timeZone: 'Canada/Mountain', });
							InterviewDateTimezoneWise = moment(Mountain).valueOf();
							getTimeZoneDetails = "Mountain Time";
						}
						if(getUserTimezone == 2) {
							Central = datea.toLocaleString('en-US', { timeZone: 'Canada/Central', });
							InterviewDateTimezoneWise = moment(Central).valueOf();
							getTimeZoneDetails = "Central Time";
						}
						if(getUserTimezone == 3) {
							Eastern = datea.toLocaleString('en-US', { timeZone: 'Canada/Eastern', });
							InterviewDateTimezoneWise = moment(Eastern).valueOf();
							getTimeZoneDetails = "Eastern Time";
						}
					}
					edited = edited.replace(/{{InterviewDate}}/g, moment.unix(InterviewDateTimezoneWise)._isValid ? moment(InterviewDateTimezoneWise).format('MM-DD-YYYY') : ''); 
					edited = edited.replace(/{{InterviewTime}}/g, moment.unix(InterviewDateTimezoneWise)._isValid ? `${moment(InterviewDateTimezoneWise).format('hh:mm A')} ${getTimeZoneDetails}` : ''); 
				} else {
					edited = edited.replace(/{{InterviewDate}}/g, ''); 
					edited = edited.replace(/{{InterviewTime}}/g, ''); 
				}

				// OFFICE
				edited = edited.replace(/{{OfficeName}}/g, officeName);
				edited = edited.replace(/{{OfficeAddress}}/g, mergeOfficeAddress);

				// MANAGER
				edited = edited.replace(/{{ManagerFirstName}}/g, managerFirstName);
				edited = edited.replace(/{{ManagerLastName}}/g, managerLastName);
				edited = edited.replace(/{{ManagerEmail}}/g, managerEmail);
				edited = edited.replace(/{{ManagerNumber}}/g, managerNumber);
				
				let msg = edited;
				if (this.OldMessage) {
					msg = edited + ' \n <br> <div style="border-bottom: 1px solid #e8e8e8;"></div>'+  this.OldMessage
				}
				return msg
			},
			signbody() {
				if(this.checkSign == 1) {
					return '<div class="signDivStyleManage">'+this.user.EmailSignature+'</div>';
				} else {
					return '';
				}
			},
			replyClick() {
				this.isReply = true;
				this.emailData.type = 'withoutDetails';
				this.selectedToValue = this.emailData.message.TO;
				if (this.emailData.message.Inbound) {
					this.selectedToValue = this.emailData.message.From;
				}
				
				// this.selectedCCValue = this.emailData.message.CC;
				// this.selectedBCCValue = this.emailData.message.BCC;
				this.OldMessage = this.emailData.message.Content;
				this.Subject = this.emailData.message.Subject;
				this.Message = '';
				
			},
			replyAllClick(){
				this.isReply = true;
				this.emailData.type = 'withoutDetails';
				this.selectedToValue = this.emailData.message.TO;
				if (this.emailData.message.Inbound) {
					this.selectedToValue = this.emailData.message.From;
				}
				this.selectedCCValue = this.emailData.message.CC;
				this.selectedBCCValue = this.emailData.message.BCC;
				this.OldMessage = this.emailData.message.Content;
				this.Subject = this.emailData.message.Subject;
				this.Message = '';
			}
			
			
		},
		data() {
            return {
				disabledStatus:true,
				From:this.emailData.user.SendGrid ? this.emailData.user.SendGrid : '',
				// From:'',
				dynamicTags: '',
				Subject:'',
				Message:'',
				MessageSign:'',
				nameState:null,
				TemplateName:'',
				selectedToValue:[],
				selectedCCValue:[],
				selectedBCCValue:[],
				SelectedTemplate:'',
				fileName:'',
				fileData:null,
				filePath:'',
				attachmentArray:[],
				uploadedURL:'',
				filesArray:[],
				isReply:false,
				OldMessage:'',
				isSending:false,
				SelectEmailTempl:'Select Email Template',
				emailSignCheckBoxSelected:false,
            }
        },
		created() {
			if (Object.keys(this.emailData).length) {
				if (this.emailData.type == 'withoutDetails') {
					this.From=this.emailData.user.SendGrid
					this.getSelectedTO();
				}
				if (this.emailData.type == 'openedFromAssessment') {
					this.Message = this.emailData.message.Content;
					this.Subject = 'Assessment Results for '+ this.emailData.Name
				}
			}
		}
	}
</script>

<style>
.dynamicformdivemail{
	background: rgb(230 246 254 / 50%);
    padding: 5px;
    margin-bottom: 0px!important;
    border-left: 1px solid #ccc;
}
.dynamicformdivemail .custom-select{
	background: transparent;
	border-radius: 0px;
}
.signDivStyleManage img{
	width: 100px;
}
.ress.send-editor #quill-container img{
	width: 100px;
}
.ress.send-editor #quill-container{
	width: 80%;
    float: right;
}
.ress .ql-toolbar{
	display: none;
}
.ress .ql-editor{
	min-height: 100px;
}
.signDivStyleManage{
	margin-bottom: 15px;
}
.signDivStyleManage p{
	margin-bottom: 0px;
}
.signDivStyleManage .ql-editor {
    min-height: 100px;
}
.send-template .customdrop{
	width: 100%;
    margin: 0px!important;
}
.send-template .customdrop ul{
	width:100%!important;
	padding: 5px 0px;
	background: #003e80;
}
.send-template .customdrop ul li a{
	font-size: 14px;
	color:#fff!important;
	background: #003e80;
}
.send-template .customdrop button.btn-secondary{
	background-color: #fff!important;
    border: 1px solid #E8E8E8!important;
    min-height: 40px;
    border-radius: 5px;
    font-size: 14px;
	color:#adadad!important;
}
.removetemplspan{
	float:right;
}
div .send-template .dropdown-toggle::after {
    font-size: 18px !important;
    right: 14px!important;
}
.send-template .customdrop button.btn-secondary:focus {
    border: none;
    box-shadow: none;
}
</style>

<style scoped>
.custom-accordion button.btn.btn-outline-primary {
    position: absolute;
    right: 6px;
    top: 0;
    background: transparent;
    border: none;
    outline: none;
}
.custom-accordion button.btn.btn-outline-primary:hover {
    color: #fff;
    background-color: transparent;
    border-color: transparent;
}
.send-from input {
    border: none;color: #000 !important;font-weight: 500;
    outline: none;
}

.custom-accordion input {
    padding-right: 40px;
    background: #fff;
    color: #000 !important;
    border: 1px solid #e8e8e8;
    font-weight: 500;
}

.send-template button.btn.btn-outline-primary:focus {
    outline: none !important;
    border: none !important;
    box-shadow: none;
}
.send-template button.btn.btn-outline-primary {
    background-color: transparent !important;
    color: #007bff !important;
    border-color: transparent !important;
    outline: none;
    text-decoration: underline;
}
.custom-accordion button.btn.btn-outline-primary:focus{
	outline: none !important;
    border: none !important;
    box-shadow: none;
}
.custom-send-email input:focus{
	outline: none !important;
    border: none !important;
    box-shadow: none;
}
.pl-10{
	margin-left: 10px;
}
.cutom-inputuploder {
    border: 1px dashed #ccc;
    padding: 10px;
    border-radius: 3px;
    position: absolute;
    left: 0;
    top: 0;
    width: 294px;text-align: center;
    /* z-index: 9999; */
}
.cutom-inputuploder span {
    color: #ccc;
    display: inline-block;
    text-align: center;padding-right: 10px;
}

.attach-file-content span {
    padding-right: 10px;width: 100%;
	/* cursor: pointer; */
}

.attach-file-content {
    /* padding-left: 12px; */
    /* padding-bottom: 10px; */
    padding: 5px 10px;
    margin-bottom: 10px;
    box-shadow: 0px 0px 3px 1px #ebe7e7;
    border: 1px solid #e8e8e8;
    border-radius: 3px;
    display: flex;
    align-items: center;
}


/* custom email view style */

.custom-padding span {
    padding-right: 5px;font-size: 15px;
}
.custom-padding {
    display: flex;
    align-items: baseline;
}
.custom-email-view-from.custom-padding {
    justify-content: space-between !important;
}
span.custom-email-time {
    font-size: 12px;
}
.custom-email-view-content {
    white-space: nowrap;
    overflow: hidden;font-size: 14px;
    text-overflow: ellipsis;
}
.custom-email-view > div.custom-user-content {
    display: flex;border-bottom: 1px solid #ddd;
    padding-bottom: 6px;
    margin-bottom: 10px;
}
.custom-email-view-cc span {
    padding-right: 10px;font-size: 15px;
}
.custom-email-user {
    width: 50px !important;
    height: 50px;
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    justify-content: center;
    margin-right: 10px;
}
.custom-email-user svg.fa-icon{
	width: 50px !important;
}
.custos-email-right{
	width:calc(100% - 60px);
}
.custom-email-view-content-load{
	padding-top: 10px;
}
.custom-subject-content p {
    font-size: 19px;
    white-space: nowrap;
    overflow: hidden;
    width: 400px;
    text-overflow: ellipsis;margin: 0;
}
.custom-email-content{
	padding-left: 60px;position: relative;
}
.cusrom-label{
	font-size: 13px;margin: 0px;
}
.custom-email-view-content{
	padding-left: 60px;
}
.custos-email-right-cc{
	display: flex;justify-content: space-between;
}
.custom-email-file svg{
	fill: #000 !important;
}
.reply-btn {
    position: absolute;
    right: 0;
    top: 0;
}

.custom-subject-content {
    position: relative;
}
.custom-subject-content.reply-all{
	margin-top: 10px !important;
}

.reply-btn button {
    background: #042B79;
    color: #fff;    border-color: #042B79;
    padding: 5px 20px;
}
.reply-btn button:focus{
	background: #042B79 !important;
	box-shadow: none !important;
}
.reply-btn button:hover{
	background: #042B79 !important;
}

.reply-btn button span {
    padding-left: 10px;
}
.custom-reply-email .custom-email-content-load{
	max-height: unset;
}
.custom-email-content-load {
    max-height: 215px;
    overflow-y: auto;
}
.custom-reply-email .custom-email-content-load::after{
	position: absolute;
    left: 0;
    border-bottom: 1px solid #ddd;
    content: '';
    width: 100%;
}
.TemplateDelete{
	background: #007bff;
    padding: 2px 10px;
    color: #fff;
    border: none;
    margin-top: 7px;
    display: inline-block;
    cursor: pointer;
    border-radius: 5px;
}
.emailsigncheckbox, .emailsigncheckbox:focus-visible{width: 26px;height: 22px;margin-top: 8px;outline: none;}
.emailsigncheckbox{
	float: left;
}
</style>